export interface IDepartment {
  id?: string;
  departmentLocaleMetadata: LocaleMetadata[];
  icon: IImage;
  banner: IImage;
  departmentCategories: IDepartmentCategory[];
  numberOfCategories: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface LocaleMetadata {
  id?: string;
  name: string;
  locale: string;
}

export interface IDepartmentCategory {
  id: string;
  name: string;
}

export interface ICreateOrUpdateDepartment {
  id?: string;
  departmentLocaleMetadata?: LocaleMetadata[];
  iconImageId?: string;
  icon?: IImage;
  bannerImageId?: string;
  banner?: IImage;
  departmentCategories?: any[];
  departmentCategoryIds?: string[];
}

interface IImage {
  id: string;
  url: string;
  sizes: IImageSize[];
}

interface IImageSize {
  url: string;
  height: number;
}
